// Five CSV download buttons (dump, summary, themes, comprehend, raw).

import React from "react";
import { Button, Typography } from "@material-tailwind/react";

export function DownloadsTab({ csvDownloadHandler }) {
    return (
        <div className="font-body rounded-2xl">
            <div className="p-2 mb-2">
                <Typography as="div" className="font-body">
                    These downloads provide the option for
                    manual analysis and reporting of survey
                    data. There are three summary report
                    file downloads:
                    <ol className="list-decimal list-inside mt-2">
                        <li>By Respondent</li>
                        <li>By Question</li>
                        <li>By Theme</li>
                    </ol>
                    <p className="mt-4">
                        You can also download All Data for
                        in-depth analysis and reporting. If
                        you need help to manually analyse
                        this data and represent what
                        respondents had to say,&nbsp;contact
                        us for some friendly support
                        options.
                    </p>
                </Typography>

                <Typography className="mt-4">
                    <Button
                        type="button"
                        variant="filled"
                        className="btn btn--secondary mr-2"
                        onClick={() => csvDownloadHandler("dump")}
                    >
                        Response Data
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        className="btn btn--secondary mr-2"
                        onClick={() => csvDownloadHandler("summary")}
                    >
                        Answer Summary
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        className="btn btn--secondary mr-2"
                        onClick={() => csvDownloadHandler("themes")}
                    >
                        Themes
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        className="btn btn--secondary mr-2"
                        onClick={() => csvDownloadHandler("comprehend")}
                    >
                        Gobby Assist
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        className="btn btn--secondary mr-2"
                        onClick={() => csvDownloadHandler("raw")}
                    >
                        All Data
                    </Button>
                </Typography>
                <Typography
                    as="div"
                    className="font-body mt-4 text-sm "
                >
                    (Note: Downloads the result of the
                    survey in CSV Format, choose a report
                    layout to download. Please note that an
                    &lsquo;All Data&rsquo; download is a
                    very large file containing all data in a
                    long data format of one response per
                    line. (multiple responses of the same
                    type *will* appear on multiple lines).)
                </Typography>
            </div>
        </div>
    );
}
